import React from "react";
import Navbar from "./Navbar";
import LandingFooter from "./LandingFooter";

export default function MainLayout({ children, active }) {
  return (
    <>
      <div className="min-h-screen">
        <Navbar active={active} landing />
        <main>{children}</main>
      </div>
      <LandingFooter />
    </>
  );
}
